import { render, staticRenderFns } from "./Socket.vue?vue&type=template&id=24a0d566&scoped=true"
import script from "./Socket.vue?vue&type=script&lang=js"
export * from "./Socket.vue?vue&type=script&lang=js"
import style0 from "./Socket.vue?vue&type=style&index=0&id=24a0d566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a0d566",
  null
  
)

export default component.exports